import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import DropdownValueHandler from '../../../../../../../../shared/SuperSearch/DropdownValueHandler';
import SignEncounter from '../../Components/SignEncounter';
import isNull from '../../../../../../../../../utils/NullChecking';
import SuperICDandCPTSearch from '../../../../../../../../shared/SuperSearch/ICDAndCPTSelection/SuperICDandCPTSearch';
import { enumUtil } from '../../../../../../../../../utils/Enum';
import handleNumericCheck from '../../../../../../../../../utils/HandleNumericKeys';
import { FindFirstChild, FindSecondChild } from '../../../../../../../../../utils/FindMenuOption';
import useClaimLinkingEncounter from '../../Components/useClaimLinkingEncounter';
import { ServerRequestProtected } from '../../../../../../../../../utils/ServerDataRequest';
import { HPI_GROUPS, isSignedOrToBeCoSigned, ROS_GROUPS } from '../../Components/utils';
import CustomTemplateFormPreview from '../../Components/Custom Template Form/CustomTemplateFormPreview';
import SignatureEncounterPreview from '../../Components/SignatureEncounterPreview';

const EncounterPreview = ({ data, searchParam, setSearchParam, Data, searchValue, ...props }) => {
  let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
  const API_URL = enumUtil.controller.Claim
  const API_URL_PATIENTENCOUNTER = enumUtil.controller.PatientEncounter
  let RecentCPTs = useSelector(state => state.CodesDropDownReducer.RecentCPT)
  let isClaimViewAllowed = FindSecondChild('Billing', 'Claims', 'Claims')?.ISView
  let isCreateClaimEditAllowed = FindFirstChild('Patient', 'Create Claim For SuperBill')?.IsAdd;
  let isSuperbillEditAllowed = FindFirstChild('Patient', 'Add SuperBill')?.IsAdd;
  let isSignEditAllowed = FindFirstChild('Patient', 'Sign Encounters')?.IsAdd;

  const { mainServiceLineModal, setMainServiceLineModal, serviceLineValidation, handleOnblurServiceline, handleServiceLineChange, handleDeleteRow, modifierBody, handleSuperSearchList, handleApplyCPTs, isProcedureEdit, CPTModal, cptBody, RecentModifiers, handleViewClaim, areAllValuesNullOrEmpty, handleCreateClaim, handleEditProcedure, handleAddNewCPT, patientID, encounterID, defaultSelectedItems } = props;
  let { divClaimLinking, LoadDD, dataExist } = useClaimLinkingEncounter(patientID, encounterID, props?.setReloadAfterSave);
  useEffect(() => {
    LoadDD(searchParam?.EncounterDate);
  }, [searchParam?.EncounterDate]);
  const [isSign, setIsSign] = useState(false);

  let vitalData = data?.Vital?.[0]?.Vital?.reduce((acc, curr) => {
    acc[curr.VitalName] = curr.VitalValue;
    return acc;
  }, {});
  let qualityOfCareData = Data?.QualityOfCare;
  console.log("EncounterPreviDataVital", vitalData)

  const isVisuallyEmpty = (html = '') => {
    return html.replace(/<[^>]*>/g, '').trim() === '';
  }

  const removeTrailingEmptyLines = (html) => {
    return html.replace(/(<p><br><\/p>\s*)+$/g, '');
  }

  let noValExistTextNA = <p className="text ar-light-color">N/A</p>;
  let noValExistText = <p className="text ar-light-color">No data recorded</p>;
  let isServLineUpdated = (mainServiceLineModal?.some(serviceLine => (serviceLine.isUpdated === "true")));
  let historyofPresentIllnessNotesText = removeTrailingEmptyLines(Data?.HistoryofPresentIllnessNotes || '');
  let reviewOfSystemNotesText = removeTrailingEmptyLines(Data?.ReviewOfSystemNotes || '');

  let behavioursNotesText = removeTrailingEmptyLines(Data?.BehaviourNotes || '');
  let interventionNotesText = removeTrailingEmptyLines(Data?.InterventionNotes || '');
  let responseNotesText = removeTrailingEmptyLines(Data?.ResponseNotes || '');
  let prescriptionsNotesText = removeTrailingEmptyLines(Data?.PrescriptionsNotes || '');
  let supplementsNotesText = removeTrailingEmptyLines(Data?.SupplementsNotes || '');
  let vaccinesNotesText = removeTrailingEmptyLines(Data?.VaccinesNotes || '');
  let injectionsNotesText = removeTrailingEmptyLines(Data?.InjectionsNotes || '');
  let labsNotesText = removeTrailingEmptyLines(Data?.LabsNotes || '');
  let imagingNotesText = removeTrailingEmptyLines(Data?.ImagingNotes || '');
  let planNotesText = removeTrailingEmptyLines(Data?.PlanNotes || '');
  let followUpNotesText = removeTrailingEmptyLines(Data?.FollowUpNotes || '');

  let additionalNoteText = removeTrailingEmptyLines(Data?.AdditionalInfoNotes || '');

  const handleSaveSuperbill = () => {
    if (!isCreateClaimEditAllowed) return;
    props?.getSaveData()
  }

  let historyOfPresentIllnessData = Data?.HistoryOfPresentIllness;
  let reviewOfSystemData = Data?.ReviewOfSystem;

  ////////////// CPT ///////////////
  const [lastEncounterCPTs, setLastEncounterCPTs] = useState({})

  const LoadLastEncounterCPT = () => {
    if (!searchParam?.EncounterDate) return;
    setLastEncounterCPTs({})
    ServerRequestProtected(API_URL_PATIENTENCOUNTER + "/LastEncounterCPT", 'post', {
      "TableName": enumUtil.enumAPITableName.Encounter,
      "ID": patientID,
      "SearchCriteria": {
        "EncounterDate": searchParam.EncounterDate
      }
    })
      .then((response) => {
        setLastEncounterCPTs({
          EncounterDate: response?.count?.EncounterDate,
          CPTs: response?.Rows || []
        });
        // setPastVitalsLoaded(true);
      }).catch((error) => {
        // setIsLoading(false)
      })
  }

  // const handleApplyCPTs = () => {
  //     if(!isSuperbillEditAllowed) return;

  //     const cleanedCPTs = lastEncounterCPTs?.CPTs.map(cpt => {
  //         let { EncounterID, EncounterDate, Description, ...rest } = cpt;
  //         rest['isUpdated'] = 'true';
  //         return rest;
  //     });
  //     setMainServiceLineModal(prev => ([...prev, ...(cleanedCPTs || [])]));

  // };

  useEffect(() => {
    if (!isNull(patientID)) {
      LoadLastEncounterCPT();
    }
  }, [patientID])

  const CustomTemplateData = Data?.CustomTemplateData?.[0];
  return (
    <>
      <SignEncounter isSign={isSign} setIsSign={setIsSign} providerName={data?.Data?.ProviderName  || ''} setSearchParam={setSearchParam} getSaveData={props?.getSaveData} initialDataData={data?.Data || {}} />
      <div className='ar_encounter_preview_sceen ps-2 pe-2px'>
        <div className="d-flex flex-column gap-10">
          {CustomTemplateData?.InsertPosition === "Top" ?
            <CustomTemplateFormPreview CustomTemplateData={CustomTemplateData}/> : <></>}
          <div>
            <div className="d-flex flex-column gap-6">
              <p className='text fs-14 font-b validate-color blue-bg'>Chief Complaint</p>
              <div>
                {Data?.ChiefComplaint ?
                  <p className="text">{Data?.ChiefComplaint}</p> : noValExistText}
              </div>
            </div>
          </div>

          {defaultSelectedItems?.historyofPresentIllness &&
            <div className='d-flex flex-column gap-6'>
              <p className='text fs-14 font-b validate-color blue-bg'>History of Present Illness(HPI)</p>
              {["Fields", "Both"].includes(defaultSelectedItems.historyofPresentIllnessType) &&
                <div className="">
                  <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>HPI</p>
                  <p className='heading d-flex align-itemes-center gap-1 flex-wrap'>
                    {(() => {
                      const visibleGroups = HPI_GROUPS.map(group => ({
                        ...group,
                        selectedItems: group.items.filter(
                          item => historyOfPresentIllnessData?.[item.key] === "true"
                        ),
                      })).filter(group => group.selectedItems.length > 0);

                      return visibleGroups?.length > 0 ?
                        visibleGroups.map((group, groupIndex) => (
                          <React.Fragment key={group.title}>
                            {group.title}:{" "}
                            <span className="text">
                              {group.selectedItems.map((item, itemIndex) => (
                                <React.Fragment key={item.key}>
                                  {item.label}
                                  {itemIndex < group.selectedItems.length - 1 && ", "}
                                </React.Fragment>
                              ))}
                              {groupIndex < visibleGroups.length - 1 ? ", " : ""}
                            </span>
                          </React.Fragment>
                        )) : noValExistText
                    })()}
                  </p>
                </div>}
              {["FreeText", "Both"].includes(defaultSelectedItems.historyofPresentIllnessType) &&
                <div>
                  <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>HPI Notes</p>
                  {isVisuallyEmpty(Data.HistoryofPresentIllnessNotes) ?
                    noValExistText :
                    <p className="text" dangerouslySetInnerHTML={{ __html: historyofPresentIllnessNotesText }}></p>}
                </div>}
            </div>}
          {defaultSelectedItems?.reviewOfSystem &&
            <div className='d-flex flex-column gap-6'>
              <p className='text fs-14 font-b validate-color blue-bg'>Review of System(ROS)</p>
              {["Fields", "Both"].includes(defaultSelectedItems.reviewOfSystemType) &&
                <div className="">
                  <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>ROS</p>
                  <p className='heading d-flex align-itemes-center gap-1 flex-wrap'>
                    {(() => {
                      const visibleGroups = ROS_GROUPS.map(group => ({
                        ...group,
                        selectedItems: group.items.filter(
                          item => reviewOfSystemData?.[item.key] === "true"
                        ),
                      })).filter(group => group.selectedItems.length > 0);

                      return visibleGroups?.length > 0 ?
                        visibleGroups.map((group, groupIndex) => (
                          <React.Fragment key={group.title}>
                            {group.title}:{" "}
                            <span className="text">
                              {group.selectedItems.map((item, itemIndex) => (
                                <React.Fragment key={item.key}>
                                  {item.label}
                                  {itemIndex < group.selectedItems.length - 1 && ", "}
                                </React.Fragment>
                              ))}
                              {groupIndex < visibleGroups.length - 1 ? ", " : ""}
                            </span>
                          </React.Fragment>
                        )) : noValExistText
                    })()}
                  </p>
                </div>}
              {["FreeText", "Both"].includes(defaultSelectedItems.reviewOfSystemType) &&
                <div>
                  <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>ROS Notes</p>
                  {isVisuallyEmpty(Data.ReviewOfSystemNotes) ?
                    noValExistText :
                    <p className="text" dangerouslySetInnerHTML={{ __html: reviewOfSystemNotesText }}></p>}
                </div>}
            </div>}
          {defaultSelectedItems?.problems &&
            <div>
              <div className="d-flex flex-column gap-6">
                <p class="text fs-14 font-b validate-color blue-bg">Problems</p>

                {Data?.EncounterProblem?.length > 0 ?
                  <div className="d-flex flex-column gap-1">
                    {Data.EncounterProblem.map((prob) => (
                      <div className="d-flex align-items-center gap-1">
                        <p className='text font-m validate-color'>{prob.DiagnosisCode}</p>
                        <p className="text">{prob.Description && `- ${prob.Description}${prob.StartDate ? ',' : ''}`}</p>
                        {prob.StartDate ?
                          (<div className="d-flex align-items-center gap-1">
                            <p className='heading'>Start Date:</p>
                            <p className='text'>{prob.StartDate || <span className="text fs-11 ar-light-color fst-italic">N/A</span>}</p>
                          </div>) : <></>}
                      </div>
                    )
                    )}
                  </div> :
                  <>{noValExistText}</>}
              </div>
            </div>}
          <div className="d-flex flex-column gap-6">
            <p className='text fs-14 font-b validate-color blue-bg'>Behaviour</p>
            <div>
              {isVisuallyEmpty(behavioursNotesText)
                ? noValExistText
                : <p className="text" dangerouslySetInnerHTML={{ __html: behavioursNotesText }}></p>}
            </div>
          </div>
          <div className="d-flex flex-column gap-6">
            <p className='text fs-14 font-b validate-color blue-bg'>Intervention</p>
            <div>
              {isVisuallyEmpty(interventionNotesText)
                ? noValExistText
                : <p className="text" dangerouslySetInnerHTML={{ __html: interventionNotesText }}></p>}
            </div>
          </div>
          <div className="d-flex flex-column gap-6">
            <p className='text fs-14 font-b validate-color blue-bg'>Response</p>
            <div>
              {isVisuallyEmpty(responseNotesText)
                ? noValExistText
                : <p className="text" dangerouslySetInnerHTML={{ __html: responseNotesText }}></p>}
            </div>
          </div>
          <div className="d-flex flex-column gap-6">
            <div className="d-flex align-items-center justify-content-between">
              <p class="text fs-14 font-b validate-color blue-bg">P - PLAN</p>
            </div>
            <div className='d-flex flex-column gap-6'>
              {defaultSelectedItems?.prescriptions &&
                <div>
                  <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>Prescriptions</p>
                  <div>
                    {isVisuallyEmpty(Data.PrescriptionsNotes) ?
                      noValExistText :
                      <p className="text" dangerouslySetInnerHTML={{ __html: prescriptionsNotesText }}></p>}
                    {/* {Data?.PrescriptionsNotes ? <p className="text">{Data?.PrescriptionsNotes}</p> : noValExistText} */}
                  </div>
                </div>}
              {defaultSelectedItems?.supplements &&
                <div>
                  <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>Supplements</p>
                  <div>
                    {isVisuallyEmpty(Data.SupplementsNotes) ?
                      noValExistText :
                      <p className="text" dangerouslySetInnerHTML={{ __html: supplementsNotesText }}></p>}
                    {/* {Data?.SupplementsNotes ? <p className="text">{Data?.SupplementsNotes}</p> : noValExistText} */}
                  </div>
                </div>}
              {defaultSelectedItems?.vaccines &&
                <div>
                  <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>Vaccines</p>
                  <div>
                    {isVisuallyEmpty(Data.VaccinesNotes) ?
                      noValExistText :
                      <p className="text" dangerouslySetInnerHTML={{ __html: vaccinesNotesText }}></p>}
                  </div>
                </div>}
              {defaultSelectedItems?.injections &&
                <div>
                  <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>Injections</p>
                  <div>
                    {isVisuallyEmpty(Data.InjectionsNotes) ?
                      noValExistText :
                      <p className="text" dangerouslySetInnerHTML={{ __html: injectionsNotesText }}></p>}
                  </div>
                </div>}
              {defaultSelectedItems?.labs &&
                <div>
                  <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>Labs</p>
                  <div>
                    {isVisuallyEmpty(Data.LabsNotes) ?
                      noValExistText :
                      <p className="text" dangerouslySetInnerHTML={{ __html: labsNotesText }}></p>}
                  </div>
                </div>}
              {defaultSelectedItems?.imaging &&
                <div>
                  <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>Imaging</p>
                  <div>
                    {isVisuallyEmpty(Data.ImagingNotes) ?
                      noValExistText :
                      <p className="text" dangerouslySetInnerHTML={{ __html: imagingNotesText }}></p>}
                  </div>
                </div>}
              <div>
                <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>Notes</p>
                <div>
                  {isVisuallyEmpty(planNotesText)
                    ? noValExistText
                    : <p className="text" dangerouslySetInnerHTML={{ __html: planNotesText }}></p>}
                  {/* {isVisuallyEmpty(planNotesText) 
                 ? noValExistText 
                  : <p className="text" dangerouslySetInnerHTML={{ __html: planNotesText }}></p>} */}
                </div>
              </div>
              {defaultSelectedItems?.followUp &&
                <div>
                  <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>Follow-Up</p>
                  {isVisuallyEmpty(Data.FollowUpNotes) && !(Data?.FollowUpDate) ?
                    noValExistText :
                    <div>
                      <div className="d-flex gap-1 text-nowrap mb-1">
                        <p className='heading'>Follow-Up Date:</p>
                        <p className='text'>{Data?.FollowUpDate || <span className="text ar-light-color">N/A</span>},</p>
                      </div>
                      <div className="d-flex flex-column gap-1">
                        <p className='heading lh-12'>Notes:</p>
                        {isVisuallyEmpty(Data.FollowUpNotes) ?
                          noValExistText :
                          <p className="text" dangerouslySetInnerHTML={{ __html: followUpNotesText }}></p>}
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
                              
          {CustomTemplateData?.InsertPosition === "Bottom" ?
            <CustomTemplateFormPreview CustomTemplateData={CustomTemplateData}/>: <></>}
          <div className="d-flex flex-column gap-6">
            {(defaultSelectedItems?.documents || defaultSelectedItems?.additionalNotes) &&
              <>
                <div className="d-flex align-items-center justify-content-between">
                  <p class="text fs-14 font-b validate-color blue-bg">I - Additional INFO</p>
                </div>
                {defaultSelectedItems?.documents &&
                  <div>
                    <p class="heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3">Documents</p>

                    {Data?.EncounterDocument?.length > 0 ?
                      <div className="d-flex flex-column gap-1">
                        {Data.EncounterDocument.map((doc) => (
                          <div className="d-flex align-items-center gap-1">
                            <p className='text font-m validate-color'>{doc.FileName}</p>
                            <p className="text">{doc.Description && `- ${doc.Description}`}</p>
                          </div>
                        )
                        )}
                      </div> :
                      <>{noValExistText}</>}

                  </div>}
                {defaultSelectedItems?.additionalNotes &&
                  <div>
                    <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3'>Notes</p>
                    <div>
                      {isVisuallyEmpty(additionalNoteText) ?
                        noValExistText :
                        <p className="text" dangerouslySetInnerHTML={{ __html: additionalNoteText }}></p>}
                    </div>
                  </div>}
              </>}
            {defaultSelectedItems?.qualityOfCare &&
              <div className='bg_yellow p-2'>
                <p className='heading font-b fs-13 mb-1 leter-spacing'>Quality of Care</p>
                <div className="ar_content">
                  <div className="d-flex gap-40 align-items-center">

                    <div className="d-flex flex-column gap-2">

                      <div className="d-flex align-items-center gap-6">

                        {qualityOfCareData?.SummaryOfCareSent === "true" ?
                          <i className="icon-check fs-15 fw-900"></i>
                          :
                          <i class="icon-alert fs-11"></i>}
                        <p className="text">Summary of care sent</p>
                      </div>
                      <div className="d-flex align-items-center gap-6">

                        {qualityOfCareData?.IncomingTransferOfPatient === "true" ?
                          <i className="icon-check fs-15 fw-900"></i>
                          :
                          <i class="icon-alert fs-11"></i>}
                        <p className="text">Incoming transfer of care</p>
                      </div>

                      <div className="d-flex align-items-center gap-6">

                        {qualityOfCareData?.OutgoingTransferOfCare === "true" ?
                          <i className="icon-check fs-15 fw-900"></i>
                          :
                          <i class="icon-alert fs-11"></i>}
                        <p className="text">Outgoing transfer of care</p>
                      </div>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <div className="d-flex align-items-center gap-6">
                        {qualityOfCareData?.EducationMaterialGiven === "true" ?
                          <i className="icon-check fs-15 fw-900"></i>
                          :
                          <i class="icon-alert fs-11"></i>}
                        <p className="text">Education material given</p>
                      </div>
                      <div className="d-flex align-items-center gap-6">
                        {qualityOfCareData?.PatientDeclinedSummary === "true" ?
                          <i className="icon-check fs-15 fw-900"></i>
                          :
                          <i class="icon-alert fs-11"></i>}
                        <p className="text">Patient declined summary</p>
                      </div>
                      <div className="d-flex align-items-center gap-6">
                        {qualityOfCareData?.VirtualVisit === "true" ?
                          <i className="icon-check fs-15 fw-900"></i>
                          :
                          <i class="icon-alert fs-11"></i>}
                        <p className="text">Virtual visit</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}

            <div className='bg_yellow p-2'>
              {data?.EncounterAddendum?.length > 0 ?
                <>
                  <p className='heading font-b fs-13 mb-1 leter-spacing'>Addendum</p>
                  {data?.EncounterAddendum.map(addendum => (
                    <>
                      <div className="Addendum-content d-flex flex-column gap-2">
                        <div className="">
                          <p className='align-items-baseline ar_dot d-flex text gap-2 ps-3 mb-1'>{addendum.Notes}</p>
                          <div className='d-flex align-items-center gap-2 ps-3 ms-10'>
                            <p className='heading fs-11'>By: <span className='green-text'>{addendum.UpdatedBy}</span></p>
                            <p className='text light-clrs'>|</p>
                            <p className='heading fs-11'>Date: <span className='green-text'>{addendum.UpdateDate}</span></p>
                          </div>
                        </div>
                      </div>
                    </>))}
                </> : <></>}
            </div>

            <div className='bg_yellow p-2'>
              <div className="d-flex align-items-center justify-content-between mb-2">
                <p className='heading font-b fs-13 mb-1 leter-spacing' id={`SuperBill-${data?.Data?.EncounterID}`}>SUPERBILL</p>
                <div className="d-flex align-items-center gap-2">
                  {!isNull(data?.Data?.EncounterID) &&
                    (!isNull(data?.Data?.ClaimID) ?
                      <div className={`d-flex align-items-center cursor-pointer ${isServLineUpdated ? 'br-right-1 br-clr pe-2' : ''} ${isClaimViewAllowed ? '' : 'disable'}`}>
                        <p className='heading fs-11 validate-color' onClick={handleViewClaim}>View Claim</p>
                        <i className='icon-enrollment fs-13 lh-9'></i>
                      </div> :
                      (<div className={`d-flex align-items-center cursor-pointer ${isServLineUpdated ? 'br-right-1 br-clr pe-2' : ''} ${isCreateClaimEditAllowed ? '' : 'disable'}`}>
                        {(dataExist ?
                          (divClaimLinking) :
                          (
                            mainServiceLineModal?.some(serviceLine => !isNull(serviceLine.SuperBillID)) ?
                              <div className='d-flex align-items-center cursor-pointer' onClick={handleCreateClaim}>
                                <p className={`heading fs-11 validate-color`}>Create Claim</p>
                                <i className='icon-enrollment fs-13 lh-9'></i>
                              </div>
                              :
                              <></>

                          ))}
                      </div>))}

                  <div className="d-flex">
                    {(isSignedOrToBeCoSigned.includes(searchParam?.EncounterStatus) && isServLineUpdated) &&
                      <button className={`btn btn-orange h-100 lh-13 min-w-unset px-10 py-3px rounded ${isSuperbillEditAllowed ? '' : 'disable'} `} onClick={() => props?.getSaveData("", "", "", 'Save Edit Superbill')}>Save</button>}
                  </div>
                </div>
              </div>
              <div className="ar_content mb-2">
                <div className="d-flex align-items-center gap-1 icds-content">
                  <p className='heading pe-1'>ICD(s)</p>
                  {Data?.EncounterProblem?.length > 0 ?
                    (Data?.EncounterProblem?.map(prob => (
                      <p className='text'>{prob?.DiagnosisCode}</p>
                    ))) : noValExistTextNA}
                </div>
              </div>
              <div className="d-flex align-items-center gap-1 mb-1 justify-content-between mb-1">
                <div className='d-flex align-items-center gap-1'>
                  <p className='heading font-b fs-13 leter-spacing lh-14'>Procedure Codes</p>
                  {isSignedOrToBeCoSigned.includes(searchParam?.EncounterStatus) &&
                    <>
                      <div className={isSuperbillEditAllowed ? 'd-flex' : 'disable d-flex'}>
                        {isProcedureEdit ?
                          <i className='icon-x-cros gray-clr fw-900' onClick={handleEditProcedure}></i> :
                          <i className='icon-Icon-material-edit ar-light-color fs-11' onClick={handleEditProcedure}></i>}
                      </div>
                    </>}
                </div>
                <div className={`d-flex align-items-center gap-1 ${isSuperbillEditAllowed ? '' : 'disable'}`}>
                  {isSignedOrToBeCoSigned.includes(searchParam?.EncounterStatus) &&
                    <>
                      <div className="all_problems-preview position-relative">
                        {lastEncounterCPTs?.CPTs?.length > 0 ?
                          <>
                            <p className={`text validate-color cursor-pointer user-select-none ${isProcedureEdit ? 'br-right-1 br-clr pe-2' : ''}`} onClick={handleApplyCPTs}>{lastEncounterCPTs?.EncounterDate} - CPTs</p>
                            <div className="problem-content d-flex flex-column gap-2 hover-scrollbar ">
                              {lastEncounterCPTs?.CPTs?.map(cpt => (
                                <div className="d-flex align-items-center justify-content-between gap-20">
                                  <p className="text font-m">{cpt.ProcedureCode}</p>
                                  <p className="text font-m text-nowrap singleLine-ellispis" title={cpt?.Description}>{cpt?.Description}</p>
                                </div>
                              ))}
                            </div>
                          </> : <></>}
                      </div>
                      {isProcedureEdit ?
                        <div className='input claims_info problems-search'>

                          <i className='icon-Clip-path-group top-50 translate-middle-y'></i>
                          <div className="position-relative za-denied-status Icds">

                            <SuperICDandCPTSearch
                              type='server'
                              customData={RecentCPTs}
                              placeholder={'Add Procedure'}
                              id='ProcedureCode'
                              name='ProcedureCode'
                              onChange={(e) => handleServiceLineChange(e, 'data.RowID', 'index', 'ProcedureCode', 'isMainCPTEncounterOther')}
                              getSelectedData={(singlerow) => handleSuperSearchList(singlerow, 'index', 'ProcedureCode', false, 'CPT')}
                              searchValue={CPTModal.CPT}
                              searchBy={['display', 'Description']}
                              tableData={[
                                { columName: 'Code', bindingValue: 'display', },
                                { columName: 'Description', bindingValue: 'Description', },
                              ]}
                              ApiLink={API_URL + "/CPTInstantSearch"}
                              method='post'
                              postBody={cptBody}
                              disabled={true}
                              sup_btn='sup_btn-Inp'
                              sup_inp='superSearchVisitInp'
                              handleAddNewCode={(searchValue, name) => handleAddNewCPT(searchValue, name, 'index')}
                              // inputError={!isNull(serviceLineValidation[index]?.CPTCodeVal) ? true : false}
                              // isItemSelected={!isNull(data.ProcedureCode) ? true : false}
                              // handleonFocus={handleOnFocusServiceline}
                              // handleOnblur={handleOnBlurForHover}
                              isReadOnly={!isSuperbillEditAllowed}
                            />
                          </div>
                        </div> : <></>}
                    </>}
                </div>
              </div>
              <div className="hk-expand-table overflow-auto BorderLess-table">
                <table className="w-100">
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th className='w-212px'>Modifiers</th>
                      <th className='w-130px'>Pointers</th>
                      <th className='w-130px'>Units</th>
                      {isProcedureEdit ? <th className='w-0px'></th> : <></>}
                    </tr>
                  </thead>
                  {isProcedureEdit ?
                    <tbody>
                      <>
                        {mainServiceLineModal?.map((data, index) => {
                          console.log("dataServiceLineInfo", data);
                          // let processedAsDD = []
                          // let displayProcedureCode= DropdownValueHandler(processedAsDD, data.ProcessedAs);
                          let displayProcedureCode = data?.ProcedureCode;
                          console.log("dataServiceLineInfoindex1", serviceLineValidation);
                          console.log("dataServiceLineInfoindex2", serviceLineValidation[index]);
                          let CheckValidation = areAllValuesNullOrEmpty(serviceLineValidation[index])
                          console.log("CheckValidation", CheckValidation)
                          // let amountVals = amountValidationModal?.[data?.ServiceLineID];
                          let amountVals = {}?.[data?.ServiceLineID];
                          const AmountValidationExist = amountVals ? Object.values(amountVals).some(value => value) : null;
                          // let errorText = handleValidationErrorText(amountVals);
                          // let datas = {
                          // name: 'Claims',
                          // data: {
                          //     id: data?.ClaimID,
                          //     name: item?.PatientInfo?.NM1_03_NameFirst,
                          //     ClaimRecord: claimRecord,
                          // }
                          // };
                          // data.TransferToSecondary === null && handleTransferToSecondary(VISIT_PAYMENT_index,index,data);
                          let VISIT_PAYMENT_index = '';
                          if (data?.Deleted !== "true") {
                            return (
                              <>
                                <tr key={data.ServiceLineID}>
                                  <td className='position-relative'>
                                    <div className='input select-bg-img'>
                                      {displayProcedureCode}
                                    </div>
                                  </td>
                                  <td>
                                    <div className='hk-table-flex' >
                                      <div
                                      // className={isFocused ? "" : 'za-denied-status'} onMouseEnter={handleMouseEnter}
                                      >
                                        <SuperICDandCPTSearch
                                          type='server'
                                          customData={RecentModifiers}
                                          id='Modifier Code'
                                          name='ModifierCode1'
                                          onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                          getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode1', '', 'CPT')}
                                          searchValue={data.ModifierCode1}
                                          searchBy={['display', 'Description']}
                                          tableData={[
                                            { columName: 'Code', bindingValue: 'display', },
                                            { columName: 'Description', bindingValue: 'Description', },
                                          ]}
                                          ApiLink={API_URL + "/ModifierInstantSearch"}
                                          method='post'
                                          postBody={modifierBody}
                                          disabled={true}
                                          // placeholder={""}
                                          sup_btn='sup_btn-Inp'
                                          sup_inp='superSearchVisitInp'
                                          placeholder={false}
                                          // inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                          isItemSelected={!isNull(data.ModifierCode1) ? true : false}
                                        // handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                        // handleonFocus={handleOnFocusServiceline}
                                        // handleOnblur={(value, name) => handleOnBlurForHoverModifers(value, name, index)}
                                        />
                                      </div>
                                      <div
                                      //  className={isFocused ? "" : 'za-denied-status'} onMouseEnter={handleMouseEnter}
                                      >
                                        <SuperICDandCPTSearch
                                          type='server'
                                          customData={RecentModifiers}
                                          id='Modifier Code'
                                          name='ModifierCode2'
                                          onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                          getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode2', '', 'CPT')}
                                          searchValue={data.ModifierCode2}
                                          searchBy={['display', 'Description']}
                                          tableData={[
                                            { columName: 'Code', bindingValue: 'display', },
                                            { columName: 'Description', bindingValue: 'Description', },
                                          ]}
                                          ApiLink={API_URL + "/ModifierInstantSearch"}
                                          method='post'
                                          postBody={modifierBody}
                                          disabled={true}
                                          placeholder={false}
                                          sup_btn='sup_btn-Inp'
                                          sup_inp='superSearchVisitInp'
                                          // inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                          isItemSelected={!isNull(data.ModifierCode2) ? true : false}
                                        // handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                        // handleonFocus={handleOnFocusServiceline}
                                        // handleOnblur={(value, name) => handleOnBlurForHoverModifers(value, name, index)}
                                        />
                                        {/* {data?.Modifier2Description ? <p className="tool_tip" style={divStyle}><span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={data?.Modifier2Description}> {data?.Modifier2Description}</span></p> : null} */}
                                      </div>
                                      <div
                                      // className={isFocused ? "" : 'za-denied-status'} onMouseEnter={handleMouseEnter}
                                      >
                                        <SuperICDandCPTSearch
                                          type='server'
                                          customData={RecentModifiers}
                                          id='Modifier Code'
                                          name='ModifierCode3'
                                          onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                          getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode3', '', 'CPT')}
                                          searchValue={data.ModifierCode3}
                                          searchBy={['display', 'Description']}
                                          tableData={[
                                            { columName: 'Code', bindingValue: 'display', },
                                            { columName: 'Description', bindingValue: 'Description', },
                                          ]}
                                          ApiLink={API_URL + "/ModifierInstantSearch"}
                                          method='post'
                                          postBody={modifierBody}
                                          disabled={true}
                                          placeholder={false}
                                          sup_btn='sup_btn-Inp'
                                          sup_inp='superSearchVisitInp'
                                          // inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                          isItemSelected={!isNull(data.ModifierCode3) ? true : false}
                                        // handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                        // handleonFocus={handleOnFocusServiceline}
                                        // handleOnblur={(value, name) => handleOnBlurForHoverModifers(value, name, index)}
                                        />
                                      </div>
                                      <div
                                      // className={isFocused ? "" : 'za-denied-status'} onMouseEnter={handleMouseEnter}
                                      >
                                        <SuperICDandCPTSearch
                                          type='server'
                                          customData={RecentModifiers}
                                          id='Modifier Code'
                                          name='ModifierCode4'
                                          onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Modifier')}
                                          getSelectedData={(singlerow) => handleSuperSearchList(singlerow, index, 'ModifierCode4', '', 'CPT')}
                                          searchValue={data.ModifierCode4}
                                          searchBy={['display', 'Description']}
                                          tableData={[
                                            { columName: 'Code', bindingValue: 'display', },
                                            { columName: 'Description', bindingValue: 'Description', },
                                          ]}
                                          ApiLink={API_URL + "/ModifierInstantSearch"}
                                          method='post'
                                          postBody={modifierBody}
                                          disabled={true}
                                          placeholder={false}
                                          sup_btn='sup_btn-Inp'
                                          sup_inp='superSearchVisitInp'
                                          // inputError={!isNull(serviceLineValidation[index]?.ModifierCode1Val) || !isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? true : false}
                                          isItemSelected={!isNull(data.ModifierCode4) ? true : false}
                                        // handleAddNewCode={(searchValue, name) => handleAddNewModifier(searchValue, name, index)}
                                        // handleonFocus={handleOnFocusServiceline}
                                        // handleOnblur={(value, name) => handleOnBlurForHoverModifers(value, name, index)}
                                        />
                                        {/* {data?.Modifier4Description ? <p className="tool_tip" style={divStyle}><span className='xsm_text text-light  multi-line-truncate text-wrap overflow-hidden' title={data?.Modifier4Description}> {data?.Modifier4Description}</span></p> : null} */}
                                      </div>
                                      {/* {isReadOnly ? null : <i class="icon-search" onClick={() => handleOpenModifiers(index)}></i>} */}
                                    </div>
                                  </td>
                                  <td>
                                    <div className='hk-table-flex'>
                                      <input
                                        variant="outlined"
                                        type="text"
                                        className={!isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                          !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                          !isNull(serviceLineValidation[index]?.Pointer1ICD) ? 'form-control input_error' : 'form-control'}
                                        name="Pointer1"
                                        id="Pointer1"
                                        maxLength={2}
                                        value={data.Pointer1}
                                        // onChange={(e) => handleServiceLineChange(data.RowID, e)}
                                        onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer1')}
                                        onBlur={(e) => handleOnblurServiceline(e, index)}
                                        onKeyPress={handleNumericCheck}
                                      // readOnly={isReadOnly}
                                      />
                                      <input
                                        variant="outlined"
                                        type="text"
                                        className={!isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                          !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                          !isNull(serviceLineValidation[index]?.Pointer2ICD) ? 'form-control input_error' : 'form-control'}
                                        // className="form-control"
                                        name="Pointer2"
                                        id="Pointer2"
                                        maxLength={2}
                                        value={data.Pointer2}
                                        // onChange={(e) => handleServiceLineChange(data.RowID, e)}
                                        onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer2')}
                                        onBlur={(e) => handleOnblurServiceline(e, index)}
                                        onKeyPress={handleNumericCheck}
                                      // readOnly={isReadOnly}
                                      />
                                      <input
                                        variant="outlined"
                                        type="text"
                                        className={
                                          !isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                            !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                            !isNull(serviceLineValidation[index]?.Pointer3ICD) ? 'form-control input_error' : 'form-control'}
                                        name="Pointer3"
                                        id="Pointer3"
                                        maxLength={2}
                                        value={data.Pointer3}
                                        // onChange={(e) => handleServiceLineChange(data.RowID, e)}
                                        onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer3')}
                                        onBlur={(e) => handleOnblurServiceline(e, index)}
                                        onKeyPress={handleNumericCheck}
                                      // readOnly={isReadOnly}
                                      />
                                      <input
                                        variant="outlined"
                                        type="text"
                                        className={
                                          !isNull(serviceLineValidation[index]?.Pointer1UNI) ||
                                            !isNull(serviceLineValidation[index]?.Pointer1Val) ||
                                            !isNull(serviceLineValidation[index]?.Pointer4ICD) ? 'form-control input_error' : 'form-control'}
                                        name="Pointer4"
                                        id="Pointer4"
                                        maxLength={2}
                                        value={data.Pointer4}
                                        // onChange={(e) => handleServiceLineChange(data.RowID, e)}
                                        onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Pointer4')}
                                        onBlur={(e) => handleOnblurServiceline(e, index)}
                                        onKeyPress={handleNumericCheck}
                                      // readOnly={isReadOnly}
                                      />
                                    </div>
                                  </td>
                                  <td >
                                    <input
                                      type="text"
                                      className={`form-control units unit ${!isNull(serviceLineValidation[index]?.UnitsVal) ? 'error' : ''}`}
                                      name="Units"
                                      id="Units"
                                      variant="outlined"
                                      value={data.Units}
                                      // onChange={(e) => handleServiceLineChange(data.RowID, e)}
                                      onChange={(e) => handleServiceLineChange(e, data.RowID, index, 'Units')}
                                    // readOnly={isReadOnly ? true : false}
                                    />

                                  </td>
                                  <td className='text-center'>
                                    <span onClick={() => handleDeleteRow(index)}><i class="fs-14 icon-delete" style={{ color: 'red' }}></i></span>
                                  </td>
                                </tr>
                                {/* <tr>
                                      <td></td>
                                      {AmountValidationExist ?
                                      <td colSpan={18} className='message error_message'>
                                          <span className='xsm_heading fs-12 fst-italic '>{
                                          // errorText
                                          }</span>
                                      </td> : <></>
                                      }
                                  </tr> */}
                                {CheckValidation === true ? null :
                                  <tr>
                                    <td colSpan={12} className='message error_message'>
                                      {!isNull(serviceLineValidation[index]?.DOSFromVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.DOSFromVal} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.DOSToVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.DOSToVal} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.CPTCodeVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.CPTCodeVal} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.ModifierCode1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.ModifierCode1Val} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.ModifierCode1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.ModifierCode1UNI} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.Pointer1Val) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1Val} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.Pointer1UNI) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1UNI} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.Pointer1ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer1ICD} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.Pointer2ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer2ICD} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.Pointer3ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer3ICD} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.Pointer4ICD) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.Pointer4ICD} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.POSVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.POSVal} </p> : null}
                                      {!isNull(serviceLineValidation[index]?.UnitsVal) ? <p className='xsm_heading fs-12'> {serviceLineValidation[index]?.UnitsVal} </p> : null}
                                    </td>
                                  </tr>
                                }
                              </>
                            )
                          }
                        })}
                      </>
                    </tbody> :
                    <tbody>
                      {mainServiceLineModal?.map((data, index) => {
                        // console.log("dataServiceLineInfo",data);
                        let processedAsDD = [];
                        let displayProcedureCode = data?.ProcedureCode;
                        if (data?.Deleted !== "true") {
                          return (
                            <>
                              <tr key={data.ServiceLineID}>
                                <td className='position-relative'>
                                  <div className='input select-bg-img'>
                                    {displayProcedureCode}
                                  </div>
                                </td>
                                <td>
                                  <div className='hk-table-flex' >
                                    {[data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4]
                                      .filter(Boolean)
                                      .join(', ')}
                                  </div>
                                </td>
                                <td>
                                  <div className='hk-table-flex'>
                                    {[data.Pointer1, data.Pointer2, data.Pointer3, data.Pointer4]
                                      .filter(Boolean)
                                      .join(', ')}
                                  </div>
                                </td>
                                <td>{data.Units}</td>
                              </tr>
                            </>
                          )
                        }
                      })}
                    </tbody>}
                </table>
              </div>

            </div>
          </div>
          <SignatureEncounterPreview data={data}/>
        </div>
      </div >
    </>
  )
}

export default EncounterPreview